import React, { useState } from "react";
import { Card, ThreeDotsContainer, UpdateIcon, DeleteIcon } from "./style";
import { FiMoreVertical } from "react-icons/fi";
import { Button } from "antd";
import { FiEdit } from "react-icons/fi";
import { FiTrash2 } from "react-icons/fi";

function ServiceCard({ data, onEdit, onDelete }) {
  const [isFull, setIsFull] = useState(false);
  const [open, setOpen] = useState(false);
  return (
    <div>
      <Card>
        <div className="wrap-header">
          <img src={data.icon} className="img" alt="" />
          <div className="card-header">
            <FiMoreVertical
              className="three-dots"
              onClick={() => (open ? setOpen(false) : setOpen(true))}
            />
          </div>
        </div>
        {open && (
          <ThreeDotsContainer
            onMouseOver={() => setOpen(true)}
            onMouseOut={() => setOpen(false)}
          >
            <UpdateIcon onClick={() => onEdit(data)}>
              <FiEdit size={13} className="editicon" />
              Tahrirlash
            </UpdateIcon>
            <DeleteIcon onClick={() => onDelete(data.id)}>
              <FiTrash2 size={14} className="delicon" /> O’chirish
            </DeleteIcon>
          </ThreeDotsContainer>
        )}
        <h2 className="title">{data.title}</h2>
        <p className="desc">
          {isFull ? data.desc : data.desc.slice(0, 86)}
          <Button
            type="link"
            className="more"
            onClick={() => setIsFull(!isFull)}
          >
            <u>{isFull ? "kamroq" : " ko’proq"}</u>
          </Button>
        </p>
      </Card>
    </div>
  );
}

export default ServiceCard;
